import axios from 'axios'
import { updateVuetifyLightTheme } from '@/plugins/vuetify'
import { translations } from '../common'
import conf from './conf'
import store from '../../store'

const configData = {}

function getConfigResponse() {
  return axios.get(`${conf.value('VUE_APP_GRAPHQL_HTTP')}config`)
}

export function loadConfig(vuetifyInstance, callback) {
  if (Object.keys(configData).length === 0) {
    getConfigResponse().then(success => {
      // check client version
      store.dispatch('clientVersionCheck', success.headers['tom-client-version'])

      // set config
      const colors = JSON.parse(success.data.filter(prop => prop.key === 'colors')[0].value)
      updateVuetifyLightTheme(vuetifyInstance, colors)

      configData.logoFilename = success.data.filter(prop => prop.key === 'logoFilename')[0].value

      configData.lunchTimes = JSON.parse(success.data.filter(prop => prop.key === 'lunchTimeJSON')[0].value)
      configData.lunchTimes.forEach(minuteValue => {
        minuteValue.text = translations[minuteValue.label]
      })

      configData.securityTypes = JSON.parse(success.data.filter(prop => prop.key === 'securityTypes')[0].value)
      configData.securityTypes.forEach(type => {
        type.label = translations[type.label]
      })

      configData.questions = JSON.parse(success.data.filter(prop => prop.key === 'questionsJSON')[0].value)

      configData.mobileDriverShowDDTButton = success.data.filter(prop => prop.key === 'mobileDriverShowDDTButton')[0].value === 'true'

      configData.exportReports = JSON.parse(success.data.filter(prop => prop.key === 'exportReports')[0].value)

      configData.availableMaterials = [{ value: 'Tappeto' }, { value: 'Binder' }, { value: 'Base' }, { value: 'Cementato' }, { value: 'Stabilizzato' }]
      configData.availableMaterials.forEach(mat => {
        mat.text = translations[mat.value.toLowerCase()]
      })

      configData.foremanCategories = JSON.parse(success.data.filter(prop => prop.key === 'foremanCategories')[0].value)

      configData.pileTypes = JSON.parse(success.data.filter(prop => prop.key === 'pileTypes')[0].value)

      configData.teamTypes = JSON.parse(success.data.filter(prop => prop.key === 'teamTypes')[0].value)

      configData.fixedProjectScheduleHeight = success.data.find(prop => prop.key === 'fixedProjectScheduleHeight').value === 'true'

      configData.plannerResourcesSelectedOnBottom = success.data.find(prop => prop.key === 'plannerResourcesSelectedOnBottom').value === 'true'

      configData.draggableSchedule = success.data.find(prop => prop.key === 'draggableSchedule').value === 'true'

      configData.useBiggerFontInSchedule = success.data.find(prop => prop.key === 'useBiggerFontInSchedule').value === 'true'

      configData.showProjectDescriptionInSchedule = success.data.find(prop => prop.key === 'showProjectDescriptionInSchedule').value === 'true'

      configData.closeProgramHeader = success.data.find(prop => prop.key === 'closeProgramHeader').value === 'true'

      configData.activityRequestStatuses = JSON.parse(success.data.filter(prop => prop.key === 'activityRequestStatuses')[0].value)

      configData.vehicleRequestStatuses = JSON.parse(success.data.filter(prop => prop.key === 'vehicleRequestStatuses')[0].value)

      configData.vehicleOperations = JSON.parse(success.data.find(prop => prop.key === 'vehicleOperations').value)

      configData.resetAllowanceOnWeekend = success.data.find(prop => prop.key === 'resetAllowanceOnWeekend').value === 'true'

      configData.dpiStatuses = JSON.parse(success.data.filter(prop => prop.key === 'dpiStatuses')[0].value)

      configData.clockInGeoRefIsEnabled = success.data.find(prop => prop.key === 'clockInGeoRefIsEnabled').value === 'true'

      configData.foremanClockInIsEnabled = success.data.find(prop => prop.key === 'foremanClockInIsEnabled').value === 'true'

      configData.priorities = JSON.parse(success.data.find(prop => prop.key === 'priorities').value)

      configData.plannerEyeIsEnabled = success.data.find(prop => prop.key === 'plannerEyeIsEnabled').value === 'true'

      configData.showClockInTimeAlert = success.data.find(prop => prop.key === 'showClockInTimeAlert').value === 'true'

      configData.lunchBreak = JSON.parse(success.data.filter(prop => prop.key === 'lunchBreak')[0].value)

      configData.plannerCopyWholeDayIsEnabled = success.data.find(prop => prop.key === 'plannerCopyWholeDayIsEnabled').value === 'true'

      configData.showProjectLabel = success.data.find(prop => prop.key === 'showProjectLabel').value === 'true'

      configData.showQuotationNumber = success.data.find(prop => prop.key === 'showQuotationNumber').value === 'true'

      configData.useMultipleVehicles = success.data.filter(prop => prop.key === 'useMultipleVehicles')[0].value === 'true'

      configData.scheduleShowConfirmCheckbox = success.data.find(prop => prop.key === 'scheduleShowConfirmCheckbox').value === 'true'

      configData.scheduleOrderBySupervisor = success.data.find(prop => prop.key === 'scheduleOrderBySupervisor').value === 'true'

      configData.scheduleShowProjectSelectionOnClone = success.data.find(prop => prop.key === 'scheduleShowProjectSelectionOnClone').value === 'true'

      configData.mobileShowLayoffButton = success.data.find(prop => prop.key === 'mobileShowLayoffButton').value === 'true'

      configData.showDummyEmployees = success.data.find(prop => prop.key === 'showDummyEmployees').value === 'true'

      configData.showDistantClockInWarning = success.data.find(prop => prop.key === 'showDistantClockInWarning').value === 'true'

      configData.geoRefDistanceMt = parseInt(success.data.find(prop => prop.key === 'geoRefDistanceMt').value)

      configData.showDistantClockInWarningOnAnyClockIn = success.data.find(prop => prop.key === 'showDistantClockInWarningOnAnyClockIn').value === 'true'

      configData.clockInWarningDistanceMt = parseInt(success.data.find(prop => prop.key === 'clockInWarningDistanceMt').value)

      configData.planningResourceByQualification = success.data.find(prop => prop.key === 'planningResourceByQualification').value === 'true'

      configData.mobileShowReceipts = success.data.find(prop => prop.key === 'mobileShowReceipts').value === 'true'

      callback()
    })
  } else {
    callback()
  }
}

export function getLogoFilename() {
  return configData.logoFilename
}

export function getLunchTimes() {
  return configData.lunchTimes
}

export function getInertLunchTimesDefault() {
  let lunchTimesDefault = getLunchTimes().find(lt => lt.defaultInert)
  return lunchTimesDefault ? lunchTimesDefault.value : 0
}

export function getSecurityTypes() {
  return configData.securityTypes
}

export function getOperatorQuestionsArray() {
  return configData.questions.operator
}

export function getOperatorForemanQuestionsArray() {
  return configData.questions.operatorForeman
}

export function getDriverQuestionsArray() {
  return configData.questions.driver
}

export function getInertQuestionsArray() {
  return configData.questions.inert
}

export function getMobileDriverShowDDTButton() {
  return configData.mobileDriverShowDDTButton
}

export function getExportReports() {
  return configData.exportReports
}

export function getMaterials() {
  return configData.availableMaterials
}

export function getForemanCategories() {
  return configData.foremanCategories
}

export function getPileTypes() {
  return configData.pileTypes
}

export function getTeamTypes() {
  return configData.teamTypes
}

export function getFixedProjectScheduleHeight() {
  return configData.fixedProjectScheduleHeight
}

export function getPlannerResourcesSelectedOnBottom() {
  return configData.plannerResourcesSelectedOnBottom
}

export function getDraggableSchedule() {
  return configData.draggableSchedule
}

export function getUseBiggerFontInSchedule() {
  return configData.useBiggerFontInSchedule
}

export function getShowProjectDescriptionInSchedule() {
  return configData.showProjectDescriptionInSchedule
}

export function getCloseProgramHeader() {
  return configData.closeProgramHeader
}

export function getActivityRequestStatuses() {
  return configData.activityRequestStatuses
}

export function getVehicleRequestStatuses() {
  return configData.vehicleRequestStatuses
}

export function getVehicleOperations() {
  return configData.vehicleOperations
}

export function getResetAllowanceOnWeekend() {
  return configData.resetAllowanceOnWeekend
}

export function getDpiStatuses() {
  return configData.dpiStatuses
}

export function getClockInGeoRefIsEnabled() {
  return configData.clockInGeoRefIsEnabled
}

export function getForemanClockInIsEnabled() {
  return configData.foremanClockInIsEnabled
}

export function getPriorities() {
  return configData.priorities
}

export function getPlannerEyeIsEnabled() {
  return configData.plannerEyeIsEnabled
}

export function getShowClockInTimeAlert() {
  return configData.showClockInTimeAlert
}

export function getLunchBreak() {
  return configData.lunchBreak
}

export function getPlannerCopyWholeDayIsEnabled() {
  return configData.plannerCopyWholeDayIsEnabled
}

export function getShowProjectLabel() {
  return configData.showProjectLabel
}

export function getShowQuotationNumber() {
  return configData.showQuotationNumber
}

export function getUseMultipleVehicles() {
  return configData.useMultipleVehicles
}

export function getScheduleShowConfirmCheckbox() {
  return configData.scheduleShowConfirmCheckbox
}

export function getScheduleOrderBySupervisor() {
  return configData.scheduleOrderBySupervisor
}

export function getScheduleShowProjectSelectionOnClone() {
  return configData.scheduleShowProjectSelectionOnClone
}

export function getMobileShowLayoffButton() {
  return configData.mobileShowLayoffButton
}

export function getShowDummyEmployees() {
  return configData.showDummyEmployees
}

export function getShowDistantClockInWarning() {
  return configData.showDistantClockInWarning
}

export function getGeoRefDistanceMt() {
  return configData.geoRefDistanceMt
}

export function getShowDistantClockInWarningOnAnyClockIn() {
  return configData.showDistantClockInWarningOnAnyClockIn
}

export function getClockInWarningDistanceMt() {
  return configData.clockInWarningDistanceMt
}

export function getPlanningResourceByQualification() {
  return configData.planningResourceByQualification
}

export function getMobileShowReceipts() {
  return configData.mobileShowReceipts
}
